import React from 'react';
import Button from '../components/ui/button';
import styles from './pricing.module.css';

interface PricingProps {
  onOpenModal: () => void;
}

const Pricing: React.FC<PricingProps> = ({ onOpenModal }) => {
  return (
    <div className={styles.pageWrapper}>
      <section className={styles.pricing}>
      <div className="container">
        <h2 className={styles.pricingTitle}>Simple, Transparent Pricing</h2>
        <p className={styles.pricingSubtitle}>
          Choose the plan that fits your investment journey
        </p>
        
        <div className={styles.pricingGrid}>
          <div className={styles.pricingCard}>
            <div className={styles.pricingCardHeader}>
              <i className="fas fa-rocket pricing-card-icon"></i>
              <h3 className={styles.pricingCardTitle}>Free</h3>
            </div>
            <div className={styles.pricingCardPrice}>
              $0<span className={styles.pricingCardPricePeriod}>/month</span>
            </div>
            <ul className={styles.pricingCardFeatures}>
              <li className={styles.pricingCardFeature}>
                <i className="fas fa-check check"></i> Basic portfolio risk score
              </li>
              <li className={styles.pricingCardFeature}>
                <i className="fas fa-check check"></i> Weekly macro brief
              </li>
              <li className={styles.pricingCardFeature}>
                <i className="fas fa-check check"></i> Portfolio sync (up to 10 holdings)
              </li>
              <li className={styles.pricingCardFeature}>
                <i className="fas fa-times cross"></i> Daily intelligence
              </li>
              <li className={styles.pricingCardFeature}>
                <i className="fas fa-times cross"></i> Real-time alerts
              </li>
              <li className={styles.pricingCardFeature}>
                <i className="fas fa-times cross"></i> Advanced risk analysis
              </li>
            </ul>
            <Button variant="secondary" onClick={onOpenModal} className={styles.pricingCardCta}>
              Get Started Free
            </Button>
          </div>
          
          <div className={`${styles.pricingCard} ${styles.featured}`}>
            <div className={styles.pricingCardHeader}>
              <i className="fas fa-crown pricing-card-icon featured"></i>
              <h3 className={styles.pricingCardTitle}>Pro</h3>
              <span className={styles.pricingCardBadge}>POPULAR</span>
            </div>
            <div className={styles.pricingCardPrice}>
              $15<span className={styles.pricingCardPricePeriod}>/month</span>
            </div>
            <ul className={styles.pricingCardFeatures}>
              <li className={styles.pricingCardFeature}>
                <i className="fas fa-check check"></i> Advanced portfolio risk scoring
              </li>
              <li className={styles.pricingCardFeature}>
                <i className="fas fa-check check"></i> Daily personalized macro brief
              </li>
              <li className={styles.pricingCardFeature}>
                <i className="fas fa-check check"></i> Unlimited portfolio sync
              </li>
              <li className={styles.pricingCardFeature}>
                <i className="fas fa-check check"></i> Real-time macro alerts
              </li>
              <li className={styles.pricingCardFeature}>
                <i className="fas fa-check check"></i> Risk scenario modeling
              </li>
              <li className={styles.pricingCardFeature}>
                <i className="fas fa-check check"></i> Signal memory & trends
              </li>
            </ul>
            <Button onClick={onOpenModal} className={styles.pricingCardCta}>
              Start Pro Trial
            </Button>
          </div>
        </div>

        <div className={styles.pricingValue}>
          <h3 className={styles.pricingValueTitle}>Your Next Trade Costs More</h3>
          <div className={styles.pricingValueContainer}>
            <p className={styles.pricingValueText}>
              One bad trade based on incomplete information costs you more than a year of Briqq Pro. For less than a single commission fee ($15/mo), get institutional-level intelligence that prevents costly mistakes and identifies opportunities you're missing.
            </p>
            
            <div className={styles.pricingValueMetrics}>
              <div className={styles.pricingValueMetric}>
                <div className={styles.pricingValueMetricValue}>60x</div>
                <p className={styles.pricingValueMetricText}>ROI if Briqq helps you avoid just one 5% portfolio loss per year</p>
              </div>
              <div className={styles.pricingValueMetric}>
                <div className={styles.pricingValueMetricValue}>10+ years</div>
                <p className={styles.pricingValueMetricText}>Subscription fees earned back if you capture one 10% opportunity</p>
              </div>
            </div>
            
            <div className={styles.pricingValueNotice}>
              <p className={styles.pricingValueNoticeText}>
                <strong>Limited Time:</strong> First 1,000 users get Pro at $15/mo. Price increases to $29/mo once we reach capacity.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    </div>
  );
};

export default Pricing; 